import React from 'react'
import { Form } from 'react-bootstrap'
import DateTimeField from './DateTimeField'
import SelectRC, { Option } from 'rc-select'
import { compareItem } from './Utils/FilterSelect.tsx'
import Avatar from '../Elements/Avatar.tsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserSlash } from '@fortawesome/pro-duotone-svg-icons/faUserSlash'
import { faChevronDown } from '@fortawesome/pro-duotone-svg-icons/faChevronDown'
import { faSpinner } from '@fortawesome/pro-duotone-svg-icons/faSpinner'
import { faCheck } from '@fortawesome/free-solid-svg-icons'

class DisplayItemDossierData extends React.Component {
    constructor(props) {
        super(props)

        this.innerRef = React.createRef()

        this.state = {
            users: [],
            usersSelected: [],
            searchOptions: [],
            allOptions: [],
            tempArray: [],
            loading: false,
            timeout: null,
            value: this.props.value,
            options: [],
        }

        this.setSelectedUsers = this.setSelectedUsers.bind(this)
        this.handleUserInputChange = this.handleUserInputChange.bind(this)
        this.renderUserSearch = this.renderUserSearch.bind(this)
        this.getUserOptions = this.getUserOptions.bind(this)
        this.handleSearch = this.handleSearch.bind(this)
    }

    getName(item) {
        if (item.text) {
            return item.text
        }

        if (item.label) {
            return item.label
        }

        if (!item.profile) {
            return item.username
        }

        return (
            item.profile.last_name +
            ', ' +
            item.profile.first_name +
            (item.profile.preposition && item.profile.preposition.length > 0
                ? ' ' + item.profile.preposition
                : '')
        )
    }

    getValue() {
        let dataType = this.props.item.settings.dossier_data

        if (dataType === 'created_by' || dataType === 'modified_by') {
            return this.state.usersSelected
        } else if (dataType === 'summary') {
            return this.state.value
        } else if (dataType === 'modified_at' || dataType === 'created_at') {
            return this.state.value
        }
    }

    isSingleSelect() {
        let settings =
            this.props?.item?.def_dossier_def_field?.def_field?.settings
        if (settings && settings.multiple && settings.multiple === true) {
            return false
        }

        return true
    }

    getFormattedDate(value) {
        if (value.length <= 0) {
            return ''
        }

        let date = new Date(value)
        let dateTimeFormat = new Intl.DateTimeFormat('nl-NL', {
            dateStyle: 'medium',
            timeStyle: 'medium',
        })

        return dateTimeFormat.format(date)
    }

    renderUser(userData) {
        if (userData && userData.username) {
            return <a href={`/user/${userData.id}`}>{userData.username}</a>
        }

        return ''
    }

    fetchUserData(search) {
        const api = this.props.kedo.api()
        let params = {
            params: {},
        }

        params.params.environment = this.props.kedo.env().getEnvironmentId()

        if (search.length > 0) {
            params.params.name = search
        }
        this.setState({ loading: true })
        api.get(api.getUserEndpoint(), params)
            .then((response) => {
                let items = []
                for (let i = 0; i < response.data.results.length; i++) {
                    items.push({
                        label: response.data.results[i].username,
                        id: response.data.results[i].id,
                        value: response.data.results[i].id,
                    })
                }

                this.setState({
                    loading: false,
                    users: items,
                })
            })
            .catch((error) => {
                console.error('Error fetching user data:', error)
                this.setState({ loading: false })
            })
    }

    setSelectedUsers(items, dossierDataType) {
        if (items === null || items.length === 0) {
            this.setState({
                usersSelected: [],
                searchOptions: [],
                allOptions: [],
            })

            this.props.changeValue(dossierDataType, null)
            return
        }

        const uniqueItems = Array.from(
            new Map(items.map((item) => [item.id, item])).values()
        )

        this.setState({ usersSelected: uniqueItems })

        this.props.changeValue(
            dossierDataType,
            items.map((item) => ({
                id: item.id,
            }))
        )
    }

    handleUserInputChange(search) {
        if (this.state.timeout) clearTimeout(this.state.timeout)
        // eslint-disable-next-line react/no-direct-mutation-state
        this.state.timeout = setTimeout(() => {
            this.fetchUserData(search)
        }, 400)
    }

    mergeOptions(oldList, newList) {
        const mapByValue = new Map()

        oldList.forEach((item) => {
            mapByValue.set(item.value, item)
        })

        newList.forEach((item) => {
            mapByValue.set(item.value, item)
        })

        return [...mapByValue.values()]
    }

    getUserOptions(inputValue) {
        let params = {
            params: {
                environment: this.props.kedo.env().getEnvironment().id,
                limit: 25,
            },
        }

        if (inputValue && inputValue.trim().length > 0) {
            params.params.name = inputValue.trim()
        }

        if (this.state.showInactive !== true) {
            params.params.active = true
        }

        this.setState({ loading: true })

        this.props.kedo
            .api()
            .get(this.props.kedo.api().getUserEndpoint(), params)
            .then((response) => {
                const results = response.data.results.map((user) => ({
                    id: user.id,
                    value: user.id,
                    label: (
                        <span
                            style={
                                !user.environment_user_active
                                    ? { color: 'gray' }
                                    : null
                            }
                        >
                            <Avatar
                                key={user}
                                kedo={this.props.kedo}
                                user={{
                                    userId: user.id,
                                    username: user.username,
                                }}
                                options={{
                                    size: 25,
                                    showPresence: false,
                                }}
                            />
                            &nbsp;{this.getName(user)}
                            {!user.environment_user_active ? (
                                <FontAwesomeIcon icon={faUserSlash} />
                            ) : null}
                        </span>
                    ),
                }))

                this.setState((prevState) => ({
                    searchOptions: results,
                    allOptions: this.mergeOptions(
                        prevState.allOptions,
                        results
                    ),
                    loading: false,
                }))
            })
            .catch((error) => {
                console.error('Error fetching user options:', error)
                this.setState({ loading: false })
            })
    }

    handleSelectChange = (selectedValues, dossierDataType) => {
        const uniqueSelectedValues = Array.from(
            new Map(selectedValues.map((item) => [item.key, item])).values()
        )

        const newSelections = uniqueSelectedValues.filter(
            (item) =>
                !this.state.usersSelected.some(
                    (selected) =>
                        selected.id === item.key || selected.value === item.key
                )
        )

        const selectedOptions = newSelections.map((item) => {
            const foundOption = this.state.allOptions.find(
                (opt) => opt.value === item.key
            )

            if (foundOption) {
                return {
                    key: foundOption.value,
                    id: foundOption.id,
                    value: foundOption.value,
                    label: foundOption.label,
                }
            }

            return {
                key: item.key,
                id: item.key,
                value: item.key,
                label: item.label,
            }
        })

        const updatedSelections = [
            ...this.state.usersSelected,
            ...selectedOptions,
        ]

        this.setSelectedUsers(updatedSelections, dossierDataType)
    }

    handleDeselect = (deselectedValue, dossierDataType) => {
        const updatedSelections = this.state.usersSelected.filter(
            (user) =>
                user.id !== deselectedValue.key &&
                user.value !== deselectedValue.key
        )

        this.setSelectedUsers(updatedSelections, dossierDataType)
        this.getUserOptions()
    }

    handleSearch = (value) => {
        if (this.state.searchTimeout) {
            clearTimeout(this.state.searchTimeout)
        }

        this.setState({
            searchTimeout: setTimeout(() => {
                this.getUserOptions(value)
            }, 300),
        })
    }

    renderUserSearch(dossierDataType) {
        const { usersSelected, searchOptions, loading } = this.state

        const formattedOptions = searchOptions.map((option) => ({
            ...option,
            key: option.value,
        }))

        const formattedSelected = usersSelected.map((user) => ({
            key: user.value || user.id,
            label: user.label,
            value: user.value || user.id,
        }))

        const filterOptions = (input, option) => {
            const labelText = compareItem(option.props.children)
            return labelText.toLowerCase().includes(input.toLowerCase())
        }

        return (
            <SelectRC
                className="w-100 custom-select-react"
                id={`${this.props.item.id}-search`}
                mode={'multiple'}
                showSearch
                labelInValue
                onSearch={this.handleSearch}
                optionFilterProp="children"
                filterOption={filterOptions}
                allowClear
                loading={loading}
                placeholder={this.props.kedo.t('Search') + '...'}
                value={formattedSelected}
                onChange={(selectedItems) => {
                    this.handleSelectChange(selectedItems, dossierDataType)
                }}
                onDeselect={(deselectedValue) => {
                    this.handleDeselect(
                        { key: deselectedValue.key },
                        dossierDataType
                    )
                }}
                onClear={() => {
                    this.setState(
                        {
                            usersSelected: [],
                            searchOptions: [],
                            allOptions: [],
                            loading: false,
                        },
                        () => {
                            this.setSelectedUsers([], dossierDataType)

                            this.getUserOptions()
                        }
                    )
                }}
                suffixIcon={
                    <FontAwesomeIcon
                        spin={this.state.loading}
                        icon={this.state.loading ? faSpinner : faChevronDown}
                    />
                }
                notFoundContent={this.props.kedo.t('No items found')}
            >
                {formattedOptions.map((option) => {
                    const isSelected = usersSelected.some(
                        (selected) => selected.id == option.value
                    )

                    return (
                        <Option
                            key={option.value}
                            value={option.value}
                            disabled={isSelected}
                            style={{ opacity: isSelected ? 0.5 : 1 }}
                        >
                            {option.label}

                            {isSelected && (
                                <FontAwesomeIcon
                                    icon={faCheck}
                                    style={{
                                        marginLeft: '8px',
                                        color: 'green',
                                    }}
                                />
                            )}
                        </Option>
                    )
                })}
            </SelectRC>
        )
    }

    isSearch() {
        if (
            this.props.mode === 'search' ||
            this.props.mode === 'advanced-search'
        ) {
            return true
        }

        return false
    }

    componentDidMount() {
        this.getUserOptions()
    }

    render() {
        const dossierDataType = this.props.item.settings.dossier_data

        if (
            this.isSearch() === true &&
            (dossierDataType === 'created_by' ||
                dossierDataType === 'modified_by')
        ) {
            return this.renderUserSearch(dossierDataType)
        } else if (this.isSearch() && dossierDataType === 'summary') {
            return (
                <Form.Control
                    onChange={(event) =>
                        this.props.changeValue('summary', event.target.value)
                    }
                    onKeyPress={
                        this.props.onKeyPress
                            ? (event) =>
                                  this.props.onKeyPress(
                                      this.props.item.id,
                                      event
                                  )
                            : null
                    }
                    type="text"
                    value={this.props.value}
                />
            )
        } else if (this.isSearch() && dossierDataType === 'dossier_id') {
            return (
                <Form.Control
                    onChange={(event) =>
                        this.props.changeValue('dossierId', event.target.value)
                    }
                    onKeyPress={
                        this.props.onKeyPress
                            ? (event) =>
                                  this.props.onKeyPress(
                                      this.props.item.id,
                                      event
                                  )
                            : null
                    }
                    type="text"
                    value={this.props.value}
                />
            )
        } else if (
            this.isSearch() &&
            (dossierDataType === 'created_at' ||
                dossierDataType === 'modified_at')
        ) {
            return (
                <DateTimeField
                    {...this.props}
                    onChange={(event) =>
                        this.props.changeValue(
                            dossierDataType,
                            event.target.value
                        )
                    }
                    onKeyPress={
                        this.props.onKeyPress
                            ? (event) =>
                                  this.props.onKeyPress(
                                      this.props.item.id,
                                      event
                                  )
                            : null
                    }
                />
            )
        }

        if (!this.props.dossier || !this.props.dossier.id) {
            return ''
        }

        switch (dossierDataType) {
            case 'summary':
                return this.props.dossier.summary ?? null
            case 'dossier_id':
                return this.props.dossier.id
            case 'created_at':
                return this.getFormattedDate(this.props.dossier.created_at)
            case 'modified_at':
                return this.getFormattedDate(this.props.dossier.modified_at)
            case 'created_by':
                return this.renderUser(this.props.dossier.created_by)
            case 'modified_by':
                return this.renderUser(this.props.dossier.modified_by)
        }

        return ''
    }
}

export default DisplayItemDossierData
